import { lazy, Suspense } from "react";

import Icon from "@mui/material/Icon";
// import { Settings /* , FindInPage */, LocationOn /* , MonitorHeart */ } from "@mui/icons-material";

import {
  PATH_USER,
  PATH_DONNEE_REF,
  PATH_ROLE,
  PATH_ESPECE,
  // PATH_DASHBOARD,
  // PATH_DASHBOARD_ELEVAGE,
  // MODULE_DASHBOARD_COMPAGNIE,
  // MODULE_DASHBOARD_ELEVAGE,
  PATH_DASHBOARD_COMPAGNIE,
  MODULE_PROFIL,
  KEY_PROFIL,
  PATH_PROFIL,
  PATH_EXPLOITATION_PUBLIC,
  KEY_EXPLOITATION_PUBLIC,
  PATH_EXPLOITATION_PRIVEE,
  KEY_EXPLOITATION_PRIVEE,
  // PATH_CAMPAGNE,
  // KEY_CAMPAGNE,
  KEY_DIRECTION,
  PATH_DIRECTION,
  PATH_STRUCTURE_PRIVEE,
  KEY_STRUCTURE_PRIVEE,
  PATH_ORGANISATION_PUBLIC,
  KEY_ORGANISATION_PUBLIC,
  KEY_TAG,
  PATH_TAG,
  // PATH_DASHBOARD_TRANSHUMANCE,
  // MODULE_DASHBOARD_TRANSHUMANCE,
  /* PATH_USER_N1,
  KEY_USER_N1, */
  PATH_USER_N1_SUP,
  PATH_USER_N1_ADMIN,
  PATH_USER_N2,
  KEY_USER_N2,
  PATH_USER_N3,
  KEY_USER_N3,
  PATH_USER_N4I,
  KEY_USER_N4I,
  PATH_USER_N4R,
  KEY_USER_N4R,
  PATH_USER_N5E,
  KEY_USER_N5E,
  PATH_USER_N5P,
  KEY_USER_N5P,
  KEY_LIEU,
  PATH_LIEU,
  /* KEY_DEMANDE_IDENTIFICATION,
  PATH_DEMANDE_IDENTIFICATION,
  PATH_IDENTIFICATION,
  KEY_IDENTIFICATION, */
  KEY_SEARCH_USER,
  PATH_SEARCH_USER,
  MODULE_RACE,
  PATH_RACE_MENU,
  KEY_LOCAUX,
  PATH_LOCAUX,
  KEY_ROBE,
  PATH_ROBE,
  // MODULE_DASHBOARD_ALERT,
  // PATH_DASHBOARD_ALERT,
  KEY_USER_N1_ADMIN,
  KEY_USER_N1_SUP,
  KEY_PUCE,
  PATH_PUCE,
  KEY_LOT_PUCE,
  PATH_LOT_PUCE,
  // PATH_DASHBOARD_PUCE,
  // MODULE_DASHBOARD_PUCE,
  // PATH_DASHBOARD_USER,
  // MODULE_DASHBOARD_USER,
  /* PATH_CAMPAGNE_INTERVENTION,
  PATH_INTERVENTION,
  PATH_INTERVENTION_GPS,
  PATH_LOT_INTERVENTION,
  PATH_LOT_INTRANT,
  PATH_SEMENCE,
  PATH_INSEMINATION,
  PATH_MISE_BAS,
  PATH_PRODUCT,
  PATH_DASHBOARD_INSEMINATION, */
} from "constant/moduleInfo";
import {
  SUPER_ADMIN_ROLE,
  SUPERVISEUR_ROLE,
  ADMIN_PAYS_ROLE,
  ADMIN_DIRECTION_ROLE,
  ADMIN_SOUS_SECTEUR_ROLE,
  ADMIN_REGION_ROLE,
  ADMIN_DEPARTEMENTAL_ROLE,
  RESPONSABLE_FERME,
} from "constant/role";
import SuspenceComponent from "components/SuspenceComponent";
import GestionLieu from "layouts/donneeReference/rubrique/gestionLieu";
import GestionRaceMenu from "layouts/donneeReference/rubrique/gestionRaceMenu";
import GestionRobe from "layouts/donneeReference/rubrique/gestionRobe";
// import PuceRepartition from "layouts/dashboard/rubrique/PuceRepartition";
// import DashboardUser from "layouts/dashboard/rubrique/DashboardUser";
import Geolocation from "layouts/geolocation/pages/GeolocationHomePage";
import ROUTES_IDENTIFICATION from "layouts/identification/constant/routes";
import ROUTES_DEMO from "layouts/demoLayout/constants/route";
import ROUTES_REPRODUCTION from "layouts/reproduction/constant/routes";
import ROUTES_INTERVENTION from "layouts/intervention/constant/routes";
import ROUTES_EQUIPEMENT from "layouts/equipement/constant/routes";
import ROUTES_SANTE_ANIMALE from "layouts/santeAnimale/constant/routes";
import CONFIG from "config";

// const Dashboard = lazy(() => import("layouts/dashboard"));
const Users = lazy(() => import("layouts/gestionUsers"));
const GestionUsers = lazy(() => import("layouts/gestionUsers/rubrique"));
// const GestionUsers = lazy(() => import("layouts/gestionUsers/component/UserPage"));
const SearchUsers = lazy(() => import("layouts/gestionUsers/searchUser"));

// const Recherche = lazy(() => import("layouts/gestionAnimaux/recherche"));
// const DemandeIdentification = lazy(() => import("layouts/gestionAnimaux/DemandeIdentification"));
const DonneesRef = lazy(() => import("layouts/donneeReference"));
const GestionRole = lazy(() => import("layouts/donneeReference/rubrique/gestionRole"));
const GestionEspece = lazy(() => import("layouts/donneeReference/rubrique/gestionEspece"));
// const DashboardCategorie = lazy(() => import("layouts/dashboard/rubrique"));
const GestionProfil = lazy(() => import("layouts/donneeReference/rubrique/gestionProfil"));
// const GestionCampagne = lazy(() => import("layouts/donneeReference/rubrique/gestionCampagne"));
const GestionFerme = lazy(() => import("layouts/donneeReference/rubrique/gestionFerme"));
const GestionExploitationPrivee = lazy(() =>
  import("layouts/donneeReference/rubrique/gestionExploitationPrivee")
);
const GestionLocaux = lazy(() => import("layouts/donneeReference/rubrique/gestionLocaux"));
const GestionEntite = lazy(() => import("layouts/donneeReference/rubrique/gestionEntite"));
const GestionTag = lazy(() => import("layouts/donneeReference/rubrique/gestionTag"));
const GestionPuce = lazy(() => import("layouts/donneeReference/rubrique/gestionPuce"));
const GestionLotPuce = lazy(() => import("layouts/donneeReference/rubrique/gestionLotPuce"));

/* const Reproduction = lazy(() => import("layouts/reproduction"));
const CampagneIntervention = lazy(() =>
  import("layouts/reproduction/rubrique/campagneIntervention")
);
const Intervention = lazy(() => import("layouts/reproduction/rubrique/intervention"));
const InterventionGps = lazy(() => import("layouts/reproduction/rubrique/intervention_gps"));
const LotIntervention = lazy(() => import("layouts/reproduction/rubrique/lot_intervention"));
const LotIntrant = lazy(() => import("layouts/reproduction/rubrique/lot_intrant"));
const Semence = lazy(() => import("layouts/reproduction/rubrique/semence"));
const Insemination = lazy(() => import("layouts/reproduction/rubrique/insemination"));
const Misebas = lazy(() => import("layouts/reproduction/rubrique/misebas"));
const ProduitMisebas = lazy(() => import("layouts/reproduction/rubrique/produitMisebas"));
const DashboardInsemination = lazy(() =>
  import("layouts/dashboard/rubrique/DashboardInsemination")
); */

const routesData = [
  /* {
    type: "collapse",
    name: <span style={{ color: "black" }}>Dashboard</span>,
    key: "dashboard",
    icon: (
      <Icon fontSize="small" style={{ color: "black" }}>
        dashboard
      </Icon>
    ),
    route: PATH_DASHBOARD,
    component: (
      <Suspense fallback={<SuspenceComponent />}>
        <Dashboard />
      </Suspense>
    ),
    role: [
      SUPER_ADMIN_ROLE,
      SUPERVISEUR_ROLE,
      ADMIN_PAYS_ROLE,
      ADMIN_DIRECTION_ROLE,
      ADMIN_SOUS_SECTEUR_ROLE,
      ADMIN_REGION_ROLE,
      ADMIN_DEPARTEMENTAL_ROLE,
      RESPONSABLE_FERME,
    ],
    collapse: [
      {
        name: "Analytics",
        key: "analytics",
        route: PATH_DASHBOARD,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <Dashboard />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>{MODULE_DASHBOARD_ELEVAGE}</span>,
        key: "elevage",
        route: PATH_DASHBOARD_ELEVAGE,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <DashboardCategorie />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>{MODULE_DASHBOARD_COMPAGNIE}</span>,
        key: "compagnie",
        route: PATH_DASHBOARD_COMPAGNIE,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <DashboardCategorie />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>{MODULE_DASHBOARD_TRANSHUMANCE}</span>,
        key: "transhumance",
        route: PATH_DASHBOARD_TRANSHUMANCE,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <DashboardCategorie />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>{MODULE_DASHBOARD_ALERT}</span>,
        key: "alert",
        route: PATH_DASHBOARD_ALERT,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <DashboardCategorie />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>{MODULE_DASHBOARD_PUCE}</span>,
        key: "puce",
        route: PATH_DASHBOARD_PUCE,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <PuceRepartition />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>{MODULE_DASHBOARD_USER}</span>,
        key: "user",
        route: PATH_DASHBOARD_USER,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <DashboardUser />
          </Suspense>
        ),
        collapse: [],
      },
    ],
  }, */
  /* {
    type: "collapse",
    name: <span style={{ color: "black" }}>Identification</span>,
    key: KEY_IDENTIFICATION,
    icon: <FindInPage fontSize="small" style={{ color: "black" }} />,
    route: PATH_IDENTIFICATION,
    component: (
      <Suspense fallback={<SuspenceComponent />}>
        <Recherche />
      </Suspense>
    ),
    role: [
      SUPER_ADMIN_ROLE,
      SUPERVISEUR_ROLE,
      ADMIN_PAYS_ROLE,
      ADMIN_DIRECTION_ROLE,
      ADMIN_SOUS_SECTEUR_ROLE,
      ADMIN_REGION_ROLE,
      ADMIN_DEPARTEMENTAL_ROLE,
      RESPONSABLE_FERME,
    ],
    collapse: [

      {
        name: <span style={{ color: "black" }}>Animaux Identifiés</span>,
        key: "PATH_IDENTIFICATION",
        route: PATH_IDENTIFICATION,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <Recherche />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Demandes d&apos;identification</span>,
        key: KEY_DEMANDE_IDENTIFICATION,
        route: PATH_DEMANDE_IDENTIFICATION,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <DemandeIdentification />
          </Suspense>
        ),
        collapse: [],
      },
    ],
  }, */
  {
    type: "collapse",
    name: <span style={{ color: "black" }}>Utilisateurs</span>,
    key: "utilisateurs",
    /* icon: (
      <Icon fontSize="small" style={{ color: "black" }}>
        peopleAltIcon
      </Icon>
    ), */
    icon: (
      <Icon fontSize="small" style={{ color: "black" }}>
        people
      </Icon>
    ),
    route: PATH_USER,
    component: (
      <Suspense fallback={<SuspenceComponent />}>
        <Users />
      </Suspense>
    ),
    role: [
      SUPER_ADMIN_ROLE,
      SUPERVISEUR_ROLE,
      ADMIN_PAYS_ROLE,
      ADMIN_DIRECTION_ROLE,
      ADMIN_SOUS_SECTEUR_ROLE,
      ADMIN_REGION_ROLE,
      ADMIN_DEPARTEMENTAL_ROLE,
      RESPONSABLE_FERME,
    ],
    collapse: [
      {
        name: "Analytics",
        key: "analytics",
        route: PATH_USER,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <Users />
          </Suspense>
        ),
        collapse: [],
      },
      /* {
        name: <span style={{ color: "black" }}>Admins Nationaux</span>,
        key: KEY_USER_N1,
        route: PATH_USER_N1,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <GestionUsers />
          </Suspense>
        ),
        collapse: [],
      }, */
      {
        name: <span style={{ color: "black" }}>Admins Généraux</span>,
        key: KEY_USER_N1_ADMIN,
        route: PATH_USER_N1_ADMIN,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <GestionUsers />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Superviseurs Nationaux</span>,
        key: KEY_USER_N1_SUP,
        route: PATH_USER_N1_SUP,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <GestionUsers />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Admins Regionaux</span>,
        key: KEY_USER_N2,
        route: PATH_USER_N2,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <GestionUsers />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Admins Départementaux</span>,
        key: KEY_USER_N3,
        route: PATH_USER_N3,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <GestionUsers />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Agents Identificateurs</span>,
        key: KEY_USER_N4I,
        route: PATH_USER_N4I,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <GestionUsers />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Responsables Fermes Publiques </span>,
        key: KEY_USER_N4R,
        route: PATH_USER_N4R,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <GestionUsers />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Eleveurs </span>,
        key: KEY_USER_N5E,
        route: PATH_USER_N5E,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <GestionUsers />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Propriétaires </span>,
        key: KEY_USER_N5P,
        route: PATH_USER_N5P,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <GestionUsers />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Rechercher un utilisateur </span>,
        key: KEY_SEARCH_USER,
        route: PATH_SEARCH_USER,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <SearchUsers />
          </Suspense>
        ),
        collapse: [],
      },
    ],
  },
  {
    type: "collapse",
    name: <span style={{ color: "black" }}>Données de Référence</span>,
    key: "donnees_ref",
    // icon: <Settings fontSize="small" style={{ color: "black" }} />,
    icon: (
      <Icon fontSize="small" style={{ color: "black" }}>
        storage
      </Icon>
    ),
    route: PATH_DONNEE_REF,
    component: (
      <Suspense fallback={<SuspenceComponent />}>
        <DonneesRef />
      </Suspense>
    ),
    role: [
      SUPER_ADMIN_ROLE,
      SUPERVISEUR_ROLE,
      ADMIN_PAYS_ROLE,
      ADMIN_DIRECTION_ROLE,
      ADMIN_SOUS_SECTEUR_ROLE,
      ADMIN_REGION_ROLE,
      ADMIN_DEPARTEMENTAL_ROLE,
      RESPONSABLE_FERME,
    ],
    collapse: [
      {
        name: "Analytics",
        key: "analytics",
        route: PATH_DONNEE_REF,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <DonneesRef />
          </Suspense>
        ),
        collapse: [],
      },
      /* {
        name: <span style={{ color: "black" }}>Opérations</span>,
        key: KEY_CAMPAGNE,
        route: PATH_CAMPAGNE,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <GestionCampagne />
          </Suspense>
        ),
        collapse: [],
      }, */
      {
        name: <span style={{ color: "black" }}>Fermes publiques</span>,
        key: KEY_EXPLOITATION_PUBLIC,
        route: PATH_EXPLOITATION_PUBLIC,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <GestionFerme />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Exploitations Privées</span>,
        key: KEY_EXPLOITATION_PRIVEE,
        route: PATH_EXPLOITATION_PRIVEE,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <GestionExploitationPrivee />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Fermes Privées</span>,
        key: KEY_LOCAUX,
        route: PATH_LOCAUX,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <GestionLocaux />
          </Suspense>
        ),
        collapse: [],
      },

      {
        name: <span style={{ color: "black" }}>Fonctions</span>,
        key: "role",
        route: PATH_ROLE,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <GestionRole />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>{MODULE_PROFIL}</span>,
        key: KEY_PROFIL,
        route: PATH_PROFIL,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <GestionProfil />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Espèces</span>,
        key: "especes",
        route: PATH_ESPECE,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <GestionEspece />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>{MODULE_RACE}</span>,
        key: "race",
        route: PATH_RACE_MENU,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <GestionRaceMenu />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Directions</span>,
        key: KEY_DIRECTION,
        route: PATH_DIRECTION,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <GestionEntite />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Structures Privées</span>,
        key: KEY_STRUCTURE_PRIVEE,
        route: PATH_STRUCTURE_PRIVEE,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <GestionEntite />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Organisations</span>,
        key: KEY_ORGANISATION_PUBLIC,
        route: PATH_ORGANISATION_PUBLIC,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <GestionEntite />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Projets</span>,
        key: KEY_TAG,
        route: PATH_TAG,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <GestionTag />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Lieux</span>,
        key: KEY_LIEU,
        route: PATH_LIEU,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <GestionLieu />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Robes</span>,
        key: KEY_ROBE,
        route: PATH_ROBE,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <GestionRobe />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Lots de Puces</span>,
        key: KEY_LOT_PUCE,
        route: PATH_LOT_PUCE,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <GestionLotPuce />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Puces</span>,
        key: KEY_PUCE,
        route: PATH_PUCE,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <GestionPuce />
          </Suspense>
        ),
        collapse: [],
      },
    ],
  },
];

// export default [...routesData, ...ROUTES_IDENTIFICATION];

export const routeGeolocation = [
  {
    type: "collapse",
    name: <span style={{ color: "black" }}>Géolocalisation</span>,
    key: "Géolocation",
    // icon: <LocationOn fontSize="small" style={{ color: "black" }} />,
    icon: (
      <Icon fontSize="small" style={{ color: "black" }}>
        location_on
      </Icon>
    ),
    // route: "/sante_animal",
    route: "/geolocalisation",
    component: <Geolocation />,
    // role: ["ADMIN", "USER"],
    role: [
      SUPER_ADMIN_ROLE,
      SUPERVISEUR_ROLE,
      ADMIN_PAYS_ROLE,
      ADMIN_DIRECTION_ROLE,
      ADMIN_SOUS_SECTEUR_ROLE,
      ADMIN_REGION_ROLE,
      ADMIN_DEPARTEMENTAL_ROLE,
      RESPONSABLE_FERME,
    ],
    collapse: [],
  },
];

/* export const routeReproduction = [
  {
    type: "collapse",
    name: <span style={{ color: "black" }}>Reproduction</span>,
    key: "reproduction",
    icon: <MonitorHeart fontSize="small" style={{ color: "black" }} />,
    route: "/reproduction",
    component: (
      <Suspense fallback={<SuspenceComponent />}>
        <Reproduction />{" "}
      </Suspense>
    ),
    role: [
      SUPER_ADMIN_ROLE,
      SUPERVISEUR_ROLE,
      ADMIN_PAYS_ROLE,
      ADMIN_DIRECTION_ROLE,
      ADMIN_SOUS_SECTEUR_ROLE,
      ADMIN_REGION_ROLE,
      ADMIN_DEPARTEMENTAL_ROLE,
      RESPONSABLE_FERME,
    ],
    collapse: [
      {
        name: <span style={{ color: "black" }}>Reproduction</span>,
        key: "reproduction",
        route: "/reproduction",
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <Reproduction />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Dashboard Insémination</span>,
        key: "dashboard insemination",
        route: PATH_DASHBOARD_INSEMINATION,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <DashboardInsemination />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Campagnes interventions</span>,
        key: "campagne intervention",
        route: PATH_CAMPAGNE_INTERVENTION,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <CampagneIntervention />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Interventions</span>,
        key: "intervention",
        route: PATH_INTERVENTION,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <Intervention />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Interventions GPS</span>,
        key: "intervention-gps",
        route: PATH_INTERVENTION_GPS,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <InterventionGps />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Lots Interventions</span>,
        key: "lot-intervention",
        route: PATH_LOT_INTERVENTION,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <LotIntervention />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Lots Intrants</span>,
        key: "lot-intrant",
        route: PATH_LOT_INTRANT,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <LotIntrant />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Semences</span>,
        key: "semences",
        route: PATH_SEMENCE,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <Semence />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Inseminations</span>,
        key: "inseminations",
        route: PATH_INSEMINATION,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <Insemination />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Mise Bas</span>,
        key: "misebas",
        route: PATH_MISE_BAS,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <Misebas />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>Produits Mise bas</span>,
        key: "produits",
        route: PATH_PRODUCT,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <ProduitMisebas />
          </Suspense>
        ),
        collapse: [],
      },
    ],
  },
]; */

const routesBuilder = () => {
  const { API_URL_TRACCAR, IS_MODULE_REPRODUCTION, IS_MODULE_SANTE_ANIMAL, API_URL, CODE_CLIENT } =
    CONFIG;
  let routesCustomized = [
    ...ROUTES_IDENTIFICATION,
    ...ROUTES_INTERVENTION,
    ...ROUTES_EQUIPEMENT,
    ...(IS_MODULE_REPRODUCTION ? ROUTES_REPRODUCTION : []),
    ...(IS_MODULE_SANTE_ANIMAL ? ROUTES_SANTE_ANIMALE : []),
    // ...ROUTES_USER,
    ...routesData,
  ];
  // console.log("routesCustomized", typeof IS_MODULE_REPRODUCTION);
  if (API_URL_TRACCAR) {
    routesCustomized = [...routesCustomized, ...routeGeolocation];
  }

  /* if (MODULE_REPRODUCTION) {
    routesCustomized = [...routesCustomized, ...ROUTES_REPRODUCTION];
  } */
  if (CODE_CLIENT !== "ci") {
    routesCustomized = routesCustomized.map((item) => ({
      ...item,
      collapse: item?.collapse?.filter((i) => i?.route !== PATH_DASHBOARD_COMPAGNIE),
    }));
  }
  if (API_URL?.includes("localhost")) {
    routesCustomized = [...routesCustomized, ...ROUTES_DEMO];
  }
  return routesCustomized;
};
export default routesBuilder();
